import React from 'react';

import { OpsApprovalsPanel } from '../components/OpsApprovalsPanel';

import { PageShell } from '@/components/page-shell';

/**
 * Operations approvals - Admin only. Supplier prices above the quote wait
 * here before Accounts pays, and items ops cannot book wait for the
 * itinerary-change OK. Sidebar item `ops-approvals`.
 */
export const OpsApprovalsPage = (): React.JSX.Element => (
  <PageShell
    title="Operations approvals"
    description="Price increases over the quote and itinerary changes waiting for your decision."
  >
    <OpsApprovalsPanel />
  </PageShell>
);
